import { connect } from 'react-redux'
import storage from 'util/storage'
import { emptyArr } from 'util/arrays'
import { isBlank } from 'util/strings'
import {
  selectRoomsByIdWithContact,
  selectRoomIdFromUrl,
} from 'ducks/chat/selectors/rooms'
import { selectRoomAssignmentLabel } from 'ducks/chat/selectors/assignment'
import {
  doOpenRoomPageById,
  doReadRoom,
  doUnreadRoom,
  doSetRoomStateToClosed,
  doSetRoomStateToOpen,
} from 'ducks/chat/actions/rooms'
import { selectConversationAgentCollisions } from 'ducks/collisions/selectors'
import { snoozeLabel } from 'util/snooze'
import { replaceParamInUrl } from 'util/params'
import { selectChannelIdFromUrl } from 'ducks/widgets/selectors/widgets'
import ListItemView from './view'

const select = (_, initialOwnProps) => {
  const roomId = initialOwnProps.conversationId

  return state => {
    const room = selectRoomsByIdWithContact(state)[roomId]
    const currentRoomId = selectRoomIdFromUrl(state)

    if (!room) {
      return {
        present: false,
      }
    }
    const currentChannelId = selectChannelIdFromUrl(state)
    const collision = selectConversationAgentCollisions(state, roomId)

    let snippetType = room.lastMessageIsNote ? 'internal' : 'reply'
    let hasDraft = false
    let snippetText = room.lastMessage
    const drafts = storage.get(`cider_editor_state_${room.matrixRoomId}`, {
      ignoreNamespace: true,
    })
    if (drafts && drafts.length > 0) {
      hasDraft = true
      snippetText = drafts[0].text
      snippetType = 'draft'
    }
    const hasContactName = !isBlank(room.contact.name)

    // Current active conversation can never be unread because your looking at it
    const isUnread =
      roomId === currentRoomId && !room.ignoreNextClose ? false : !room.isRead

    return {
      ...collision,
      present: true,
      customerLabelFull: hasContactName ? room.contact.name : room.title,
      hasDraft,
      isUnread,
      assignmentLabel: selectRoomAssignmentLabel(state, room),
      timestamp: room.lastActivityAtInHuman,
      messageCount: null,
      hasAttachments: false,
      isStarred: room.isStarred,
      subject: hasContactName ? room.title : null,
      snippetType,
      snippetAuthor: room.lastMessageSender,
      snippetText,
      mailboxColor: !currentChannelId ? room.collectionColor : null,
      labelIds: emptyArr,
      isCloseable: room.isCloseable,
      shouldShowLabels: false,
      labelsJSON: '[]',
      active: roomId === currentRoomId,
      linkUrl: replaceParamInUrl('conversationId', roomId),
      canBulkSelect: false,
      isSnoozed: room.isSnoozed,
      snoozedUntilLabel: snoozeLabel(room.snoozedUntil),
      lastMessageIsNote: room.lastMessageIsNote,
      lastMessageEventId: room.lastMessageEventId,
      matrixRoomId: room.matrixRoomId,
      expiryEvent: room.expiryEvent,
    }
  }
}

const perform = dispatch => {
  return {
    /* eslint-disable no-console */
    closeConversation: id => dispatch(doSetRoomStateToClosed(id)),
    openConversation: id => dispatch(doSetRoomStateToOpen(id)),
    markAsRead: id => dispatch(doReadRoom(id, { afterUpdateMessage: false })),
    markAsUnread: id =>
      dispatch(
        doUnreadRoom(id, { afterUpdateMessage: false, ignoreNextClose: true })
      ),
    onClick: action => console.log(`NOTIMPLEMENTED: onClick ${action}`),
    navigateToConversation: id => dispatch(doOpenRoomPageById(id)),
    toggleConversationSelection: id =>
      console.log(`NOTIMPLEMENTED: toggleConversationSelection ${id}`),
    /* eslint-enable no-console */
  }
}

export default connect(select, perform)(ListItemView)
